export default {"src":"/_next/static/media/logout.f847dea5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};